// See: https://github.com/petkaantonov/bluebird#for-library-authors
module.exports = require("bluebird/js/main/promise")();
